module.exports = __webpack_public_path__ + "img/place1.e5457372.png";